import React, { useState, useEffect } from 'react';
import ImportConfirmation from '../Confirmation/ImportConfirmation';
import './Import.css';
import { gaEvents } from '../../util/events';

function Import({ activeTab, wallet }) {
  const [nfts, setNfts] = useState([]);
  const [activeNft, setActiveNft] = useState([]);
  const [isConfirming, setIsConfirming] = useState(false);

  useEffect(() => {
    let suiNfts = [];
    if (wallet.contents) {
      suiNfts = wallet.contents.nfts;
    }
    const talofaNFTs = [];
    suiNfts.forEach((nft) => {
      if (nft.name === 'Beta Frost Generator') {
        talofaNFTs.push(nft);
      }
    });
    gaEvents.loadImportNfts(talofaNFTs.length);
    setNfts(talofaNFTs);
    // console.log(wallet, wallet.contents.nfts, 'contents');
  }, [wallet]);

  function onCloseModal() {
    setIsConfirming(false);
  }

  function loadNft(nft) {
    setIsConfirming(true);
    setActiveNft(nft);
  }

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  async function refresh() {
    await delay(2000);

    // console.log('Waited 2s');
    let suiNfts = [];
    if (wallet.contents) {
      suiNfts = wallet.contents.nfts;
    }
    const talofaNFTs = [];
    suiNfts.forEach((nft) => {
      if (nft.name === 'Beta Frost Generator') {
        talofaNFTs.push(nft);
      }
    });
    setNfts(talofaNFTs);
  }

  let suiNfts = [];
  if (wallet && wallet.contents) {
    suiNfts = wallet.contents.nfts;
  }
  const talofaNFTs = [];
  suiNfts.forEach((nft) => {
    if (nft.name === 'Beta Frost Generator') {
      talofaNFTs.push(nft);
    }
  });
  //   console.log(wallet, 'wallet');
  //   setNfts(talofaNFTs);

  return (
    <div>
      <ImportConfirmation
        isShowLogin={isConfirming}
        onCloseModal={onCloseModal}
        refresh={refresh}
        nft={activeNft}
        wallet={wallet}
        walletAddress={wallet.address}
      />
      {talofaNFTs.length === 0
        && <h1 className="second-header no-nft-message">No NFTs Available</h1>}
      {talofaNFTs.length === 0
        && <h2 className="warning second-header no-nft-message">To refresh NFTs in your wallet try using the disconnect button</h2>}

      {talofaNFTs.length > 0
      && (
      <div className="nft-market">
        {talofaNFTs && talofaNFTs.map((nft, index) => (
          <div
            className="nft border  rounded-xl overflow-hidden"
            onClick={() => { loadNft(nft); }}
            key={index}
          >
            <div className="nft-content">
              <div className="nft-img-container">
                <img className="nft-img" src={nft.imageUrl} />
              </div>
              <p className="nft-name">{nft ? nft.name : 'empty'}</p>
              <p className="mint-text nft-id">{nft ? nft.objectId : ''}</p>
              <p className="mint-text">Ready to import!</p>
            </div>
          </div>
        ))}
      </div>
      )}
    </div>
  );
}

export default Import;
